import React from "react";
import Box from "@mui/material/Box";
import { reduxForm } from "redux-form";


import { useDispatch, useSelector } from "react-redux";
import Button from "@mui/material/Button";
import LinearProgress from "@mui/material/LinearProgress";
import FormBuilder, { IMedAppFormField } from "../../../form";

import { Agent } from "../../../../models";
import { required, minLength, email } from "../../../form/utils/validations";
import { createModel } from "../../store/actions";
import { selectCreatingModel } from "../../store/selectors";
import { capitalize } from "lodash";

const phoneCodes = ["+234", "+1", "+44"].map((v) => ({ label: v, value: v }));

const AgentCreateForm: React.FC<any> = ({
  mFields,
  name,
  handleSubmit,
  onSubmit,
}) => {
  const handleSubmitCallback = (value: any) => {
    onSubmit(value);
  };
  return (
    <form onSubmit={handleSubmit(handleSubmitCallback)}>
      {" "}
      <FormBuilder fields={mFields} name={name} />
      <Button type="submit" variant="contained">
        Continue
      </Button>
    </form>
  );
};

const AgentCreateReduxForm = reduxForm<any, any>({
  form: "agent-create",
})(AgentCreateForm);

const AgentCreate: React.FC<{
  agent?: Agent;
}> = ({ agent }) => {
  const dispatch = useDispatch();
  const creating = useSelector(selectCreatingModel("agent"));

  const fields: IMedAppFormField[] = React.useMemo(
    () => [
      {
        name: "Email",
        label: "Email Address",
        type: "email",
        validate: [email],
      },
      {
        name: "FirstName",
        label: "First Name",
        type: "text",
        validate: [required, minLength(2)],
      },
      {
        name: "LastName",
        label: "Last Name",
        type: "text",
        validate: [required, minLength(2)],
      },
      {
        name: "phone",
        label: "Phone Number",
        type: "text",
        childFields: [
          {
            variant: "select",
            inputExtras: phoneCodes,
            name: "countryCode",
            defaultValue: "+234",
            label: "Country Code",
            type: "text",
          },

          {
            name: "phoneNumber",
            placeholder: "0000-0000-0000-0000",
            label: "Phone Number",
            validate: [required, minLength(10)],
            type: "text",
          },
        ],
      },

      {
        name: "Password",
        label: "Password",
        type: "password",
        inputExtras: {
          disabled: !!agent,
        },
        validate: !agent ? [required] : [],
      },

      {
        name: "divider",

        type: "text",
        variant: "divider",
      },
      {
        name: "Address",
        label: "Adress",
        type: "text",
        inputExtras: {
          multiline: true,
        },
        defaultValue: "Eti-Osa",
        validate: [required, minLength(2)],
      },
      {
        name: "BirthDate",
        label: "Birth Date",
        type: "text",
        variant: "date-picker",
        validate: [required],
      },
    ],
    [agent]
  );

  const handleSubmit = (value: any) => {
    const data = { ...value };
    console.log(data);
    delete data.phone;
    delete data.location;
    data.Name = capitalize(`${data.FirstName} ${data.LastName}`)
    delete data.FirstName;
    delete data.LastName;
    if (!data.BirthDate) {
      return;
    }
    data.BirthDate = value.BirthDate.getTime();
    data.Status = 1;
    data.PhoneNumber =
      (value.phone.countryCode || "+234") + value.phone.phoneNumber;
    data.Location = { placeId: "null", location: "No Location Provided" };

    dispatch(
      createModel({
        model: data,
        modelName: "agent",
      })
    );
  };

  return (
    <Box
      style={{
        width: "100%",
      }}
    >
      <Box
        sx={{
          width: "70%",
          maxWidth: "700px",
          minWidth: "250px",
          marginLeft: "1em",
        }}
      >
        {creating && <LinearProgress />}
        <AgentCreateReduxForm
          mFields={fields}
          namel="kosy-2"
          onSubmit={handleSubmit}
        />
      </Box>
    </Box>
  );
};

export default AgentCreate;
